import { Button, Dialog, DialogContentText, Divider } from "@material-ui/core";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import "./datePickerCustomStyle.css";

import { BasicFormLabel, LeftSideV2Styles } from "./LeftSideV2Styles";
import { updateMultipleData } from "../../LeftSide/inboxAction";
import CustomModal from "../common/CustomModal/CustomModal";
import BasicSelectWithSearch from "../../../GlobalAddDealModalV3/BasicSelectWithSearch";
import { updateContactBusinessInfo } from "../../../../api/contactApi";
import BasicSelect from "../../../custom/BasicSelect";
import { BasicInput } from "../RightSideStyle";
import { BUSINESS_CLASSIFICATION_OPTIONS, BUSINESS_TYPE_OPTIONS } from "../../../../constants/CoreConstants";

const EditBusinessInfoModal = ({ open, onClose, contactBusinessInfo }) => {
  const { contact } = useSelector((state) => state.rightsideReducer);
  const dispatch = useDispatch();
  const { primaryButton, closeButton } = LeftSideV2Styles();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    type_of_business: "",
    business_classification: "",
    fein: "",
    dba: "",
    year_business_started: "",
    years_of_management_experience: "",
    number_of_employees: "",
    annual_revenue: "",
    total_payroll: "",
  });

  useEffect(() => {
    if (contactBusinessInfo) {
      setFormData({
        type_of_business: contactBusinessInfo.type_of_business || "",
        business_classification: contactBusinessInfo.business_classification || "",
        fein: contactBusinessInfo.fein || "",
        dba: contactBusinessInfo.dba || "",
        year_business_started: contactBusinessInfo.year_business_started || "",
        years_of_management_experience: contactBusinessInfo.years_of_management_experience || "",
        number_of_employees: contactBusinessInfo.number_of_employees || "",
        annual_revenue: contactBusinessInfo.annual_revenue || "",
        total_payroll: contactBusinessInfo.total_payroll || "",
      });
    }
  }, [contactBusinessInfo]);

  const handleInputField = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleUpdateContact = async () => {
    setIsSubmitting(true);
    try {
      const res = await updateContactBusinessInfo({
        ...formData,
        contactId: contact.id,
      });

      if (res.success) {
        const updatedContactInfo = {
          ...contact,
          business_information: {
            ...contact.business_information,
            type_of_business: formData.type_of_business,
            business_classification: formData.business_classification,
            fein: formData.fein,
            dba: formData.dba,
            year_business_started: formData.year_business_started,
            years_of_management_experience: formData.years_of_management_experience,
            number_of_employees: formData.number_of_employees,
            annual_revenue: formData.annual_revenue,
            total_payroll: formData.total_payroll,
          },
        };

        dispatch(updateMultipleData({ contact: updatedContactInfo }));
        window.showNotification("SUCCESS", res.message);
        onClose(true);
      } else {
        window.showNotification("ERROR", res.message);
      }
    } catch (error) {
      window.showNotification("ERROR", "Something went wrong while updating contact information.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth={1200}
    >
      <CustomModal icon={<BusinessCenterIcon />} title='Update Business Information' open={open} onClose={onClose} />
      <DialogContentText id='alert-dialog-description'>
        <div style={{ width: "750px", padding: "12px 20px" }}>
          <div style={{ display: "flex", width: "100%", flexDirection: "column", gap: "16px" }}>
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>Type of Business</BasicFormLabel>
                <BasicSelect
                  fullWidth
                  name='businessType'
                  options={BUSINESS_TYPE_OPTIONS}
                  defaultText='Select type of business'
                  value={formData.type_of_business}
                  onChange={(e) => handleInputField("type_of_business", e.target.value)}
                  mapping={{
                    label: "title",
                    value: "value",
                  }}
                />
              </div>

              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>Business Classification</BasicFormLabel>
                <BasicSelectWithSearch
                  fullWidth
                  options={BUSINESS_CLASSIFICATION_OPTIONS}
                  mapping={{
                    label: "display_name",
                    value: "id",
                  }}
                  defaultText='Select type of business'
                  placeholderText='Search Business Classification...'
                  value={formData.business_classification}
                  onChange={(e) => handleInputField("business_classification", e.target.value)}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>FEIN #</BasicFormLabel>
                <BasicInput
                  fullWidth
                  placeholder='Enter FEIN'
                  value={formData.fein}
                  onChange={(e) => handleInputField("fein", e.target.value)}
                />
              </div>

              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>DBA</BasicFormLabel>
                <BasicInput
                  fullWidth
                  placeholder='Enter DBA'
                  value={formData.dba}
                  onChange={(e) => handleInputField("dba", e.target.value)}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
            <div style={{ flex: 1, minWidth: '300px' }} className='business_started_year'>
              <BasicFormLabel variant="body1">Year Business Started</BasicFormLabel>
              <DatePicker
                selected={formData.year_business_started ? new Date(formData.year_business_started) : null}
                onChange={(date) => {
                  const year = date ? date.getFullYear().toString() : '';
                  handleInputField("year_business_started", year);
                }}
                showYearPicker
                dateFormat="yyyy"
                placeholderText="Select Year"
                maxDate={new Date()}
                className="react-datepicker-wrapper"
              />
            </div>

              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>Years of Management Experience</BasicFormLabel>
                <BasicInput
                  type='number'
                  fullWidth
                  placeholder='Enter Management Experience'
                  value={formData.years_of_management_experience}
                  onChange={(e) => handleInputField("years_of_management_experience", e.target.value)}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>Number of Employees</BasicFormLabel>
                <BasicInput
                  type='number'
                  fullWidth
                  placeholder='Enter Number of Employees'
                  value={formData.number_of_employees}
                  onChange={(e) => handleInputField("number_of_employees", e.target.value)}
                />
              </div>

              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>Annual Revenue</BasicFormLabel>
                <BasicInput
                  fullWidth
                  placeholder='Enter Annual Revenue'
                  value={formData.annual_revenue}
                  onChange={(e) => handleInputField("annual_revenue", e.target.value)}
                />
              </div>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 1, minWidth: "300px" }}>
                <BasicFormLabel variant='body1'>Total Payroll</BasicFormLabel>
                <BasicInput
                  fullWidth
                  placeholder='Enter Total Payroll'
                  value={formData.total_payroll}
                  onChange={(e) => handleInputField("total_payroll", e.target.value)}
                />
              </div>

              <div style={{ flex: 1, minWidth: "300px" }}></div>
            </div>
          </div>

          <Divider light style={{ marginTop: "20px" }} />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              marginTop: "16px",
            }}
          >
            <Button
              variant='contained'
              color='primary'
              disableElevation
              className={primaryButton}
              onClick={handleUpdateContact}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Updating..." : "Update Contact"}
            </Button>
            <Button className={closeButton} variant='contained' color='secondary' disableElevation onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </DialogContentText>
    </Dialog>
  );
};

export default EditBusinessInfoModal;
